import React from 'react';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
// import MessagesModal from '../../../elements/MessagesModal';
import axe from '../../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import { getDDFDocument } from '../../../../constants';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxTutelaLegale({
  insuranceRequest,
  statues,
  // messagesModalData,
  rc_quotation,
  risk_quotations,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation));

    return total.toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="documents-status-step-one pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statues.find((stat) => stat.id === rc_quotation.status).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.gender !== 'G'
                    ? `${insuranceRequest.customer.name} ${insuranceRequest.customer.surname}`
                    : insuranceRequest.customer.business_name}
                </dd>
              </DetailItem>
              {insuranceRequest.customer.plate_number && (
                <DetailItem>
                  <dt>Targa Veicolo</dt>
                  <dd>{insuranceRequest.customer.plate_number}</dd>
                </DetailItem>
              )}
              {rc_quotation.risk_information && (
                <DetailItem>
                  <dt>Massimale Fatturato</dt>
                  <dd>
                    &euro;
                    {' '}
                    {rc_quotation.risk_information.massimale ? parseFloat(
                      rc_quotation.risk_information.massimale,
                    ).toLocaleString('en-US') : parseFloat(
                      rc_quotation.massimale,
                    ).toLocaleString('en-US')}
                  </dd>
                </DetailItem>
              )}
              <DetailItem>
                <dt>Decorrenza</dt>
                <dd>
                  {new Date(
                    insuranceRequest.policy_effective_date,
                  ).toLocaleDateString('it-IT')}
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
              {rc_quotation.company_id === 15 && rc_quotation.product_id === 9 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    23,
                    0,
                  )}
                >
                  Informazioni Precontrattuali Arag
                </DocChip>
              )}
              {rc_quotation.company_id === 16 && rc_quotation.product_id === 9 && rc_quotation.sub_product === 'patente_motor' && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    37,
                    0,
                  )}
                >
                  Informazioni Precontrattuali Patente Motor
                </DocChip>
              )}
              {rc_quotation.company_id === 16 && rc_quotation.product_id === 9 && rc_quotation.sub_product === 'vita_privata' && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    38,
                    0,
                  )}
                >
                  Informazioni Precontrattuali Vita Privata
                </DocChip>
              )}
              {rc_quotation.company_id === 16 && rc_quotation.product_id === 9 && rc_quotation.sub_product === 'tutela_professionale' && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    48,
                    0,
                  )}
                >
                  Informazioni Precontrattuali Professionale
                </DocChip>
              )}
            </DocChips>

            <ActionRow>
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          <ProductsTableCard total={getTotal()}>
            <tr>
              <td>
                {rc_quotation.product.name}
                {' '}
                {rc_quotation.risk_information && (
                  <>
                    (
                    {rc_quotation.risk_information.product_name}
                    )
                  </>
                )}
              </td>
              <td>
                {rc_quotation.company_id !== null
                  ? rc_quotation.company.name
                  : rc_quotation.preventivas_company.company_name}
              </td>
              <td>
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td>
                    {
                      quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name
                    }
                  </td>
                  <td>{quote.company.name}</td>
                  <td>
                    {parseFloat(quote.amount).toFixed(2)}
                    {' '}
                    &euro;
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxTutelaLegale;
